import { useState, useEffect, useCallback } from 'react';
import { PosMesaService } from '../services/posMesaService';
import { usePosStore } from '../store/posStore';
import type { PisoResponse, MesaResponse } from '../types/pos.types';

export const usePosRestaurante = () => {
  const [pisos, setPisos] = useState<PisoResponse[]>([]);
  const [pisoActivo, setPisoActivo] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [mesaSeleccionada, setMesaSeleccionada] = useState<MesaResponse | null>(null);
  const { sesionActiva } = usePosStore();

  const loadPisos = useCallback(async () => {
    if (!sesionActiva) return;
    setLoading(true);
    try {
      const data = await PosMesaService.getPisos(sesionActiva.idSucursal);
      setPisos(data);
      if (data.length > 0 && pisoActivo === 0) {
        setPisoActivo(data[0].idPiso);
      }
    } catch (error) {
      console.error('Error loading pisos:', error);
    } finally {
      setLoading(false);
    }
  }, [sesionActiva, pisoActivo]);

  useEffect(() => {
    loadPisos();
  }, [loadPisos]);

  // Auto-refresh every 15 seconds
  useEffect(() => {
    const interval = setInterval(loadPisos, 15000);
    return () => clearInterval(interval);
  }, [loadPisos]);

  const mesasDelPiso = pisos.find((p) => p.idPiso === pisoActivo)?.mesas ?? [];

  const cambiarEstadoMesa = async (idMesa: number, estado: string) => {
    await PosMesaService.cambiarEstado(idMesa, estado);
    await loadPisos();
  };

  const asignarMozo = async (idMesa: number, idMozo: number) => {
    await PosMesaService.asignarMozo(idMesa, idMozo);
    await loadPisos();
  };

  const transferirMesa = async (idMesa: number, idMesaDestino: number) => {
    await PosMesaService.transferirMesa(idMesa, { idMesaDestino });
    await loadPisos();
  };

  const separarCuenta = async (idMesa: number, itemIds: number[]) => {
    await PosMesaService.separarCuenta(idMesa, { itemIds });
    await loadPisos();
  };

  return {
    pisos,
    pisoActivo,
    setPisoActivo,
    mesasDelPiso,
    mesaSeleccionada,
    setMesaSeleccionada,
    loading,
    loadPisos,
    cambiarEstadoMesa,
    asignarMozo,
    transferirMesa,
    separarCuenta,
  };
};
